import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-navy py-10" data-id="element-79" data-mp="207t4gfx6vxoq">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 text-center sm:px-6" data-id="element-80" data-mp="207b1l0g0ul7u">
        <p className="font-heading text-lg font-bold uppercase tracking-wide text-white" data-id="element-81" data-mp="2f41z1464xmut">
          🏫 Educación Física FLASH
        </p>
        <a href="mailto:manualeslistos@gmail.com" className="flex items-center gap-1.5 text-sm text-white/70 transition-colors hover:text-yellow" data-id="element-82" data-mp="1mfwd4e3chrte">
          <MailIcon size={14} data-id="element-83" data-mp="1hf8fh9km2cq7" />
          manualeslistos@gmail.com
        </a>
        <p className="max-w-md text-sm leading-relaxed text-white/60" data-id="element-84" data-mp="1w7abujnh2nlh">
          Sistema de sesiones listas para el patio. Para profesores que quieren dejar de improvisar.
        </p>
        <p className="text-xs text-white/40" data-id="element-85" data-mp="13o3murfnukpd">
          © Educación Física FLASH {new Date().getFullYear()} — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}